angular.module('aprima-patient-api').factory('ConsentRepository',
    ['AprimaRestangular', function (AprimaRestangular) {
        'use strict';

        function getPracticeConsent(uid) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('consents/' + uid + '/practiceconsent').get();
        }

        function getChartConsent(userId) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('consents/' + userId + '/chartconsent').get();
        }

        function postChartConsent(userId) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('consents/' + userId + '/chartconsent').customPOST();
        }

        function getAgreementPrivacyPolicyPath(uid) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('consents/' + uid + '/agreementprivacypolicypath').get();
        }

        function getAgreementPrivacyPolicyImage(requestSettings) {
            var restangular = AprimaRestangular.get('patient');

            var queryString = '?page=' + requestSettings.page + '&height=' + requestSettings.height + '&width=' + requestSettings.width;
            return restangular.one('consents/agreementprivacypolicyimage/' + queryString).get();
        }

        function downloadAgreementPrivacyPolicy() {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('consents/agreementprivacypolicy/').get();
        }

        function postUserAgreedToPracticeConsent(uid) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('consents/' + uid + '/practiceconsent').customPOST();
        }

        function downloadApiDocumentation() {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('consents/apidocumentation/').get();
        }
        
        return{
            getPracticeConsent: getPracticeConsent,
            getChartConsent: getChartConsent,
            getAgreementPrivacyPolicyPath: getAgreementPrivacyPolicyPath,
            postUserAgreedToPracticeConsent: postUserAgreedToPracticeConsent,
            postChartConsent: postChartConsent,
            getAgreementPrivacyPolicyImage: getAgreementPrivacyPolicyImage,
            downloadAgreementPrivacyPolicy: downloadAgreementPrivacyPolicy,
            downloadApiDocumentation: downloadApiDocumentation
        };
    }]);